<style>
	.vm2_wrapper{
    z-index:900 !important;
	}
</style> 

<template>
	<span>
		<button :disabled="button_disabled" v-b-modal="'lockModal_'+position_id+'_'+color+'_'+cell_id+'_'+isolation_location" class="btn btn-primary" :class="btnClass"><i class="fa fa-lock" :class="lockIconClass"></i></button>
		<b-modal :id="'lockModal_'+position_id+'_'+color+'_'+cell_id+'_'+isolation_location" @ok="selectLock">
			<template slot="modal-header">
				<h4 class="modal-title">Lakat választás <span v-if="user">{{user.name}} részére</span></h4>
				<a class="btn-close" @click="$bvModal.hide('lockModal_'+position_id+'_'+color+'_'+cell_id+'_'+isolation_location)"></a>
			</template>
				<input type="text" v-model="search" placeholder="keresés..." class="form-control">
				<div class="row overflow-auto" style="max-height: 400px;">
					<div class="col-2 my-2" v-for="(lock,id) in filteredLocks" :key="id">
						<button class="btn btn-lg rounded-pill" :class="{'bg-primary bg-opacity-20': lock.id != lock_id && !lock.position_id && color == 1, 'bg-black bg-opacity-20': lock.id != lock_id && !lock.position_id && color == 4, 'bg-red bg-opacity-20': lock.id != lock_id && !lock.position_id && color == 3, 'btn-outline-warning': lock.id == lock_id, 'bg-yellow': lock.position_id}" @click="lock_id = lock.id" :disabled="lock.position_id">
							<span class="fa-stack">
								<i class="fa-solid fa-lock fa-stack-2x" :class="{'text-primary':color == 1,'text-black-strict':color == 4,'text-red':color == 3}"></i>
								<i class="fa-solid fa-stack-1x text-white fs-12px mt-6px">{{lock.name}}</i>
							</span>
						</button>
					</div>
				</div>
			<template #modal-footer="{cancel,ok }">
				<b-button variant="default" @click="cancel()">
					Mégse
				</b-button>
				<PinSignatureSimple v-if="user" :user_id="user.id" @signed="selectLock" :hideSignButton="!user.pin_set" ref="pin_signature" :disabled_sign="lock_id == null"></PinSignatureSimple>
				<b-button variant="primary" @click="ok()" v-else>
					Kiválaszt
				</b-button>
			</template>
		</b-modal>
	</span>
</template>

<script>
	import PinSignatureSimple from './PinSignatureSimple';
export default {
	components: {
		PinSignatureSimple
	},
	props: { locks: Array, position_id: Number, button_disabled: Boolean, large: Boolean, btnClass: String , lockIconClass: String, color: Number, cell_id: String, isolation_location: Number, user:Object },
	data() {
		return {
			lock:null,
			lock_id:null,
			search:"",
		}
	},
	computed:{
		filteredLocks: function(){
			return this.locks.filter(item => {
				return item.name.toString().toLowerCase().includes(this.search.toLowerCase())
			})
		},
	},
	methods:{
		resetSignature(){
			this.$refs['pin_signature'].resetStatus();
		},
		selectLock(bvModalEvt){
			if(this.lock_id != null){
				this.$emit('lock_selected',{position_id: this.position_id, lock_id:this.lock_id});
				this.$bvModal.hide('lockModal_'+this.position_id+'_'+this.color+'_'+this.cell_id+'_'+this.isolation_location);
			}else{
				bvModalEvt.preventDefault();
				this.$swal({
					toast: true,
					position: 'bottom-right',
					iconColor: 'red',
					showConfirmButton: false,
					timer: 3000,
					timerProgressBar: true,
					icon: 'error',
					title: 'Válasszon lakatot!'
				});
			}
		}
	}
};
</script>
